import { render, staticRenderFns } from "./BillingLimitModal.vue?vue&type=template&id=6c510d46&"
import script from "./BillingLimitModal.vue?vue&type=script&lang=js&"
export * from "./BillingLimitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports